import React from "react"
import RulesPage from "../pages/analizator"

const Demo = ({ pageContext, location }) => {
    // console.log('Demo', pageContext);
    return <RulesPage location={location} data={pageContext.data}  text={pageContext.text} isDemo={true} textTitle={"Ion"} textAuthor={"Liviu Rebreanu"}/>
}

export default Demo
